export default "__VITE_ASSET__CnflryBM__"